export enum RoiPageVisibilityStatus {
    PARTIAL = 'PARTIAL',
    FULL = 'FULL',
}
